import { Navigate, useRoutes } from "react-router-dom";
import Layout from "../components/Layout";
import HomePage from "../pages/HomePage";
import Privacy from "../pages/Privacy";
import PrivacyIos from "../pages/PrivacyIos";
import { AdminRoutes } from "./admin";

export const AppRoutes = () => {
  const routes = [
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <HomePage /> },
        { path: "privacy", element: <Privacy /> },
        { path: "privacy-ios", element: <PrivacyIos /> },
        { path: "admin/*", element: <AdminRoutes /> },
        { path: "*", element: <Navigate to="/" /> },
      ],
    },
  ];

  const element = useRoutes(routes);
  return <>{element}</>;
};
